import ReactGA from 'react-ga4';
////////////////////////////////////////////////////////////////////
import { BackButton, PageTitle, SkinsList } from '@/app/shared/components';
import { useEffect } from 'react';

/**
 * Skins component that displays a page with a title "Skins".
 * It sends a pageview hit to Google Analytics for tracking.
 * The component is structured using a flexible and centered layout.
 */
const Skins: React.FC = () => {
	/*********************
	// #region Observables
	**********************/
	useEffect(() => {
		ReactGA.send({
			hitType: 'pageview',
			page: '/skins',
			title: 'Skins',
		});
	}, []);

	/*********************
	// #region Template
	**********************/
	return (
		<div className="flex flex-col gap-2 pt-8 pb-32 mx-4">
			<BackButton />
			<div className="flex flex-col items-center">
				<PageTitle>Skins</PageTitle>
			</div>
			<SkinsList />
		</div>
	);
};

export default Skins;
